// @ts-nocheck
import { ICard } from '../components/kanbanBoard/models/BoardModel';
import { IProjectModel } from '../models/ProjectModel';
import { IProjectTaskModel } from '../models/ProjectTaskModel';
import { PhaseSortTypes } from '../models/SortTypes';

export const filterBySearchTerm = (
  tasks: IProjectTaskModel[],
  searchTerm: string | null
): IProjectTaskModel[] => {
  const formattedSearchTerm = searchTerm.trim().toLowerCase();
  if (!searchTerm) {
    return tasks;
  }

  return tasks.filter(
    (task) =>
      task?.taskName?.toLowerCase().includes(formattedSearchTerm) ||
      task?.taskNumber?.toLowerCase().includes(formattedSearchTerm) ||
      task?.taskTag?.toLowerCase().includes(formattedSearchTerm) ||
      task?.assignedUser?.fullName.toLowerCase().includes(formattedSearchTerm)
  );
};

export const filterKanbanBySearchTerm = (
  cards: ICard<IProjectTaskModel>[],
  searchTerm: string | null
): ICard<IProjectTaskModel>[] => {
  const formattedSearchTerm = searchTerm.trim().toLowerCase();
  if (!searchTerm) {
    return cards;
  }

  return cards.filter(
    (card) =>
      card?.content?.taskName?.toLowerCase().includes(formattedSearchTerm) ||
      card?.content?.taskNumber?.toLowerCase().includes(formattedSearchTerm) ||
      card?.content?.taskTag?.toLowerCase().includes(formattedSearchTerm) ||
      card?.content?.assignedUser?.fullName.toLowerCase().includes(formattedSearchTerm)
  );
};

export const sortTasks = (tasks: IProjectTaskModel[], sortOrderId: number): void => {
  if (sortOrderId === PhaseSortTypes.Default) {
    tasks.sort((item1, item2) => item1.orderPosition - item2.orderPosition);
  } else if (sortOrderId === PhaseSortTypes.Priority) {
    const maxPriority = Math.max(...tasks.map((item) => item.priorityId));
    tasks.sort((item1, item2) => {
      if (item1.priorityId === item2.priorityId) {
        return item1.priorityOrderPosition - item2.priorityOrderPosition;
      }
      return (item1.priorityId ?? maxPriority + 1) - (item2.priorityId ?? maxPriority + 1);
    });
  } else {
    tasks.sort((item1, item2) => {
      const date1 = item1.updatedAt || item1.createdAt;
      const date2 = item2.updatedAt || item2.createdAt;

      return Date.parse(date2!) - Date.parse(date1!);
    });
  }
};
